<h1 mat-dialog-title>Artikelcode scannen</h1>
<div mat-dialog-content>
  <div class="scanner-container">
    @if (showOverlay) {
      <div class="scanner-overlay">
        @if (torchCompatible) {
          <button mat-icon-button (click)="torch = !torch"
            class="scanner-overlay-torch-button">
            <mat-icon>{{torch ? 'flash_off' : 'flash_on'}}</mat-icon>
          </button>
        }
        <div class="scanner-overlay-stroke"></div>
      </div>
    }

    <zxing-scanner [formats]="allowedFormats"
      [torch]="torch"
      (deviceChange)="currentDevice = $event?.deviceId ?? undefined"
      [device]="(selectedCamera | async) ?? undefined"
      [enable]="cameras.length > 0"
      (camerasFound)="foundCameras($event)"
      (autostarted)="showOverlay = true"
      (permissionResponse)="!$event ? permissionsDenied() : ''"
      (camerasNotFound)="createErrorMessage()"
      (scanError)="createErrorMessage()"
      (torchCompatible)="torchCompatible = $event"
      (scanSuccess)="scanSuccess($event)">
    </zxing-scanner>
  </div>

  <p>
    Für einen erfolgreichen Scan: Gerät gerade halten, möglichst wenig bewegen und auf ausreichende Belichtung achten.
  </p>

  <mat-form-field appearance="fill" class="camera-dropdown">
    <mat-label>Kamera</mat-label>
    <mat-select [value]="currentDevice" (selectionChange)="setSelectedCamera($event.value)">
      @for (camera of cameras; track camera; let i = $index) {
        <mat-option
          [value]="camera.deviceId">
          {{camera?.label}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-stroked-button (click)="this.dialogRef.close()">Abbrechen</button>
</div>
